import { Box } from '@mui/material';
import React from 'react';
import HeaderLogo from '../../LeadsForms/MainLeadForms/HeaderLogo';
import IconContainer from './components/IconContainer';

const Card = ({ t }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#037A68',
        zIndex: '999',
        paddingTop: '32px',
        paddingBottom: '3px',
        gap: '22px',
        borderRadius: { md: '15px' },
        boxShadow: '0px 34px 114px rgba(0, 0, 0, 0.08)',
        width: { xs: '100%', md: '480px' },
        minHeight: { xs: '100vh', md: '100%' },
        marginTop: { md: '10%' },
      }}
    >
      <HeaderLogo t={t} />
      <IconContainer t={t} />
    </Box>
  );
};

export default Card;
